import {textFilter}    from "react-bootstrap-table2-filter"
import {selectFilter}  from "react-bootstrap-table2-filter"
import {numberFilter}  from "react-bootstrap-table2-filter"
export const FILTERS = {
  TEXT   : textFilter,
  SELECT : selectFilter,
  NUMBER : numberFilter
}
